import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './styles/ViewStudents.css';
import Header from './components/Header';
import LoadingPage from './components/LoadingPage';
import StudentCard from './components/StudentCard';
import ErrorPage from './components/ErrorPage';

const ViewStudents = () => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortCriteria, setSortCriteria] = useState('grade');
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch students data
    useEffect(() => {
        const fetchStudents = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/students`);
                const fetchedStudents = response.data;
                sortStudents(sortCriteria, fetchedStudents); // Sort immediately after fetching
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchStudents();
    }, [API_URL, sortCriteria]); // Only re-fetch students if the API_URL or sortCriteria change

    // Sort students based on the sort criteria
    const sortStudents = (criteria, studentsList) => {
        let sortedStudents;
        if (criteria === 'lastname') {
            sortedStudents = [...studentsList].sort((a, b) => 
                `${a.last_name}`.localeCompare(`${b.last_name}`)
            );
        } else if (criteria === 'firstname') {
            sortedStudents = [...studentsList].sort((a, b) =>
                `${a.first_name}`.localeCompare(`${b.first_name}`)
            );
        } else if (criteria === 'grade') {
            sortedStudents = [...studentsList].sort((a, b) => b.grade - a.grade);
        }
        setStudents(sortedStudents);
    };

    // Handle search input change
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Handle sort change
    const handleSortChange = (e) => {
        setSortCriteria(e.target.value);
    };

    const filteredStudents = students.filter(student => {
        const fullName = `${student.first_name} ${student.last_name}`.toLowerCase();
        const grade = `${student.grade}`.toLowerCase();
        const tools = student.list_of_trained_tools || [];

        return (
            fullName.includes(searchTerm.toLowerCase()) ||
            grade.includes(searchTerm.toLowerCase()) ||
            tools.some(tool => tool.tool_name && tool.tool_name.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    });

    if (loading) return <LoadingPage />;
    if (error) return <ErrorPage />;

    return (
        <div>
            <Header />
            <div className="students-container">
                <h1>Empower your creativity with the makerspace and collaborate with fellow students.</h1>
                <p>Explore all the students who have ventured into the realm of creation inside the makerspace.</p>
                    <div className="search-sort-container">
                        <input
                            type="text"
                            placeholder="Enter a student name, grade level, or tool name"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            className="search-bar"
                        />
                        <select value={sortCriteria} onChange={handleSortChange} className="sort-dropdown">
                            <option value="lastname">Sort By: Last Name A → Z </option>
                            <option value="firstname"> Sort By: First Name A → Z </option>
                            <option value="grade">Sort By: Grade Level</option>
                        </select>
                    </div>
                    <div className="students-grid">
                        {filteredStudents.map((student, index) => (
                        <StudentCard key={index} student={student} />
                    ))}
                    </div>
                </div>
            </div>
    );
};

export default ViewStudents;
